import { QUEUE_TABS } from '@hooks/useReportQueue'

/**
 * All / Running / Scheduled / Ready / Didn't finish.
 *
 * These counts are the ONLY summary on the page — the design review cut the
 * stat-tile row above the table ("the top summary must not compete with the
 * tables, since that's where people spend most of their time").
 */
/**
 * @param {object|null} counts  per-tab counts, or NULL when the read that would
 *   have produced them did not resolve. `null` is not `{}` — an empty object is a
 *   read that returned nothing, and renders honest zeros. Defaulting `null` to
 *   `{}` here would reinstate the exact defect (CC-53101), so it is handled
 *   explicitly at the badge instead.
 */
const QueueStateTabs = ({ active = 'all', counts = {}, onChange }) => (
  <div className="flex border-b border-gray-200 px-1.5" role="tablist" aria-label="Filter the queue by state">
    {QUEUE_TABS.map((t) => {
      const on = t.key === active
      return (
        <button
          key={t.key}
          type="button"
          role="tab"
          aria-selected={on}
          onClick={() => onChange?.(t.key)}
          className={`flex items-center gap-1.5 border-b-2 px-3.5 py-2.5 text-[12.5px] font-medium transition-colors ${
            on ? 'border-cb-accent-text font-semibold text-cb-accent-text' : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          {t.label}
          <span className={`rounded-full px-1.5 py-px text-[10px] font-bold ${on ? 'bg-cb-accent/15 text-cb-accent-text' : 'bg-gray-100 text-gray-600'}`}>
            {/* An em dash, not a 0 and not a blank: the badge keeps its shape so
                the tab row does not reflow, and a reader can see the number is
                withheld rather than zero. `aria-label` says it in words, because
                "—" alone is announced inconsistently across screen readers. */}
            {counts == null
              ? <span aria-label="count unavailable">—</span>
              : (counts[t.key] ?? 0)}
          </span>
        </button>
      )
    })}
  </div>
)

export default QueueStateTabs
